import { getDeviceId } from 'usage-tracker-core/common/defaultTrackers';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import TrackerContainer from '../tracking/TrackerContainer';
export const getUserExperimentIdentifier = () => getDeviceId(TrackerContainer.trackingByCookiePreferenceEnabled() ? undefined : anonymousStorage);